import React from 'react';
import {connect} from 'react-redux';

import {Grid} from '@mui/material';

import {createResource} from 'spectra-logic-ui/actions';
import {FormDialog} from 'spectra-logic-ui/components';
import {Dispatch} from 'spectra-logic-ui';

import {Activate} from '@/help';
import TextField from '@/components/form/text_field';
import {FormValues} from '@/accounts/form/types';

type Props = {
  onSubmit: (values: FormValues) => Promise<any>;
}

export const alternateTip = `
The alternate endpoint should normally be left blank. It is provided
for unusual situations where the standard activation sequence is
unavailable.
`;


const ActivateDialog = ({onSubmit, ...otherProps}: Props) => (
  <FormDialog title='Activate' onSubmit={onSubmit} getHelpLocation={() => Activate} {...otherProps}>
    {() => (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField name='key' label='Sphere Activation Key' />
        </Grid>
        <Grid item xs={12}>
          <TextField name='url' label='Alternate Endpoint'
            helperText='Normally left blank.'
            tooltip={alternateTip}/>
        </Grid>
      </Grid>
    )}
  </FormDialog>
);

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (values: FormValues) => dispatch(createResource('sphere/activate', values)),
});

export default connect(undefined, mapDispatchToProps)(ActivateDialog);
